module.exports = __webpack_public_path__ + "static/media/ace.ff440f1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/clients/ace.png
// module id = 222
// module chunks = 0